export const AuthRole = {

    getRolePermissionOnlyShowLidaHomes(permissionValue){
        
      
        var organizationId =    localStorage.getItem('organizationId');
        if(organizationId=="66f6989c2191596fe7f1c46f" || organizationId=="66f16bb68657dd00c9332538" ){
            return true;
        }
        return false;

    },  
    
    getRolePermission(permissionValue){
        
      
     var permissionRoleForAdmin =    localStorage.getItem('role_id');
   

    //  if (permissionRoleForAdmin == 1|| permissionRoleForAdmin ==2 ||permissionRoleForAdmin ==12 ||permissionRoleForAdmin ==13) {
    //     return true
    //  }
    var isAdmin =    localStorage.getItem('isAdmin');
    if(isAdmin=='Y'){
        return true
    }
     var permissionRole =    localStorage.getItem('permission_role');
     if(!permissionRole){
        return false
     }
     var t= permissionRole.split(" ");
    
    return  t.includes(permissionValue)
    },

    getRolePermissionHR(permissionValue){
        
      
        var permissionRoleForAdmin =    localStorage.getItem('role_id');
      
   
      
     if (permissionRoleForAdmin == 26) {
        return true
     }
       var isAdmin =    localStorage.getItem('isAdmin');
       if(isAdmin=='Y'){
           return true
       }
        var permissionRole =    localStorage.getItem('permission_role');
        if(!permissionRole){
           return false
        }
        var t= permissionRole.split(" ");
       
       return  t.includes(permissionValue)
       },

    getRolePermissionY(permissionValue){
        
        var permissionRole =    localStorage.getItem('permission_role');
        if(!permissionRole){
           return false
        }
        var t= permissionRole.split(" ");
       
       return  t.includes(permissionValue)
       },
    
    getRoleName(){
      
        var permissionRole =    localStorage.getItem('role_id');
        if(!permissionRole){
           return ""
        }
        return  permissionRole;
    },

    getRolePermissionForParent(permissionValue) {
       // return true
        var permissionRoleForAdmin =    localStorage.getItem('role_id');

        if (permissionRoleForAdmin == 1|| permissionRoleForAdmin ==2 ||permissionRoleForAdmin ==12 ||permissionRoleForAdmin ==13) {
           return true
        }
        var isAdmin =    localStorage.getItem('isAdmin');
        if(isAdmin=='Y'){
            return true
        }
       
        var returnData =  false;
        var permissionRole = localStorage.getItem('permission_role');
        if (permissionRole) {
            var t = permissionRole.split(" ");
        
         
            permissionValue.forEach(element => {
              
              

                var g= t.includes(element)
                if(g ==true){
                    returnData = true;
                 
                }


            });
        }else{
            returnData = false;
            // return false
        }

        return returnData

    }

}

